"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Returns the first item of an array
 * @param  {Array} array The array.
 * @returns {any}
 */

exports.first = function (array) {
  if (array === void 0) {
    array = [];
  }

  return array[0];
};
/**
 * Returns the last item of an array
 * @param   {Array} array The array.
 * @returns {any}
 */


exports.last = function (array) {
  if (array === void 0) {
    array = [];
  }

  return array[array.length - 1];
};
/**
 * Returns a random item from an array
 *
 * @param   {Array} array The array.
 * @returns {any}
 */


exports.random = function (array) {
  if (array === void 0) {
    array = [];
  }

  return array[Math.floor(Math.random() * array.length)];
};
/**
 * Determines if an array contains an item. Small polyfill for Array.includes.
 *
 * @param   {Array} array The array.
 * @param   {any} item The item to match.
 * @returns {boolean} The result.
 */


exports.includes = function (array, item) {
  if (array === void 0) {
    array = [];
  }

  return array.indexOf(item) >= 0;
};